import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { ContentHTMLTags, FeeTransparencyDisclaimer } from './types';
import { getFeeTransparencyDisclaimer } from '@/modules/trade/services/fee-transparency-disclaimer';
import {
  BaseText,
  Link,
  MessageFoundation as Message
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeeTransparencyDisclaimer',
  setup(__props) {

const disclaimer = ref<FeeTransparencyDisclaimer>({
  title: '',
  content: []
});

onMounted(async () => {
  disclaimer.value = await getFeeTransparencyDisclaimer();
});

return { __sfc: true,disclaimer, ContentHTMLTags, BaseText, Link, Message }
}

})